import Agents from '@/services/Rest/Agents';

export default {
	state: {
		agents: {},
		agentsSimple: {},
		deletedAgents: {},
		totals: {
			totalAgents: '',
			totalAdmins: ''
		}
	},
	actions: {
		fetchAgents({ commit, dispatch }) {
			return Agents.getAgents().then(response => {
				commit('setAgents', response.data.agents);
				commit('setUsersNumber', response.data);

				return Promise.resolve(response);
			});
		},
		fetchAgentsSimple({ commit, dispatch }) {
			return Agents.getAgentsSimple().then(response => {
				commit('setAgentsSimple', response.data.agents);

				return Promise.resolve(response);
			});
		},
		fetchAgent({ commit, dispatch }, id) {
			return Agents.getAgent(id);
		},
		updateAgent({ commit, dispatch }, agent) {
			return Agents.updateAgent(agent).then(
				response => { return Promise.resolve(response); },
				error => { return Promise.reject(error); }
			);
		},
		deleteAgent({ commit, dispatch }, data) {
			return Agents.deleteAgent(data);
		},
		fetchDeletedAgents({ commit, dispatch }) {
			return Agents.getDeletedAgents().then(response => {
				commit('setDeletedAgents', response.data.agents);
				commit('setUsersNumber', response.data);

				return Promise.resolve(response);
			});
		},
		restoreAgent({ commit, dispatch }, data) {
			return Agents.restoreAgent(data);
		},
		destroyAgent({ commit, dispatch }, data) {
			return Agents.destroyAgent(data);
		},
		fetchNewActiveAgents({ commit, dispatch }, data) {
			return Agents.getSortedActiveAgents(data).then(response => {
				commit('setAgents', response.data.agents);

				return Promise.resolve(response);
			});
		},
		fetchNewDeletedAgents({ commit, dispatch }, data) {
			return Agents.getSortedDeletedAgents(data).then(response => {
				commit('setDeletedAgents', response.data.agents);

				return Promise.resolve(response);
			});
		}
	},
	mutations: {
		setAgents(state, data) {
			state.agents = data;
		},
		setAgentsSimple(state, data) {
			state.agentsSimple = data;
		},
		setDeletedAgents(state, data) {
			state.deletedAgents = data;
		},
		setUsersNumber(state, data) {
			state.totals.totalAgents = data.total_agents;
			state.totals.totalAdmins = data.total_admins;
		}
	},
	getters: {
		getAgents(state) {
			return state.agents;
		},
		getAgentsSimple(state) {
			return state.agentsSimple;
		},
		getDeletedAgents(state) {
			return state.deletedAgents;
		},
		getUsersNumberFromAgents(state) {
			return state.totals;
		}
	}
};
